module.exports = __webpack_public_path__ + "img/20.af991ab3.jpg";